import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import { context } from './context';
import { DefaultPrivacyLevel, datadogRum } from '@datadog/browser-rum';
import GitInfo from 'react-git-info/macro';

// Enable Datadog RUM
if (context.env !== 'local') {
  const { commit } = GitInfo();
  datadogRum.init({
    applicationId: 'c7f6b18f-a5ae-4442-a527-8c9ba5f9fe38',
    clientToken: 'pub79e1359a4da3550046e94d44cddcce5e',
    version: commit.hash,
    site: 'us5.datadoghq.com',
    service: 'canna42-marketing-site',
    env: context.env,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: DefaultPrivacyLevel.ALLOW,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
